module.exports = __webpack_public_path__ + "files/c7cdc45d781061e93bb08ee594127ed8.png";